import PropTypes from 'prop-types'

const OpinionItem = ({ opinion }) => {
  const { Rating, message, name, location } = opinion
  return (
    <div className="p-3 bg-white rounded shadow h-100 text-center">
      <p className="mb-2">{message}</p>
      {[1, 2, 3, 4, 5].map((star) => (
        <i key={star} className={`material-icons item-star ${Rating >= star ? 'text-primary' : 'text-muted'}`}>
          star
        </i>
      ))}
      <p className="small my-2">
        <b>{name}</b>
        {', '}
        <i className="text-muted">{location}</i>
      </p>
    </div>
  )
}

OpinionItem.propTypes = {
  opinion: PropTypes.instanceOf(Object).isRequired
}

export default OpinionItem
